import { useMutation, useQueryClient } from '@tanstack/react-query';

import { resendActivationEmail } from '~/services/AgentHub/AgentService';

export function useResendActivationEmail() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (eoiId: string) => {
      return await resendActivationEmail(eoiId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-email-logs'] });
      queryClient.invalidateQueries({ queryKey: ['registration-tokens'] });
    },
  });
}
